
import { useCallback } from 'react'
import { Icon } from '@/components/ui/icon'
import { cn } from '@/lib/utils'
import type { IconName } from '@/components/ui/icon'

const TEXT_MODES: { value: string; label: string; icon: IconName }[] = [
  { value: 'TextNode', label: 'Text Node', icon: 'type' },
  { value: 'TextFile', label: 'Text File', icon: 'file-text' },
]

interface TextModeTabsProps {
  activeMode: string
  onModeChange?: (mode: string) => void
}

export function TextModeTabs({ activeMode, onModeChange }: TextModeTabsProps) {
  const handleClick = useCallback(
    (mode: string) => {
      if (mode !== activeMode) {
        onModeChange?.(mode)
      }
    },
    [activeMode, onModeChange]
  )

  return (
    <div className="border-b border-border px-3 py-3">
      <div className="flex gap-1">
        {TEXT_MODES.map(({ value, label, icon }) => (
          <button
            key={value}
            type="button"
            onClick={() => handleClick(value)}
            className={cn(
              'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-colors',
              value === activeMode
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
            )}
          >
            <Icon name={icon} className="h-3.5 w-3.5" />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
